const getExtraLimitsAge = (getMiddleNumber, getMiddleText) => {
  const minCustomerAge = getMiddleNumber('ADHERENT_DATE_NAISSANCE_AGE_MINIMUM');
  const maxCustomerAge = getMiddleNumber('ADHERENT_DATE_NAISSANCE_AGE_MAXIMUM');
  const customerAgeInfoText = getMiddleText('ADHERENT_DATE_NAISSANCE_AGE_INFO', {
    minCustomerAge,
    maxCustomerAge
  });

  const minSpouseAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MINIMUM_SPOUSE');
  const maxSpouseAge = getMiddleNumber('BENEFICIAIRE_DATE_NAISSANCE_AGE_MAXIMUM_SPOUSE');
  const spouseAgeInfoText = getMiddleText('BENEFICIAIRE_DATE_NAISSANCE_AGE_SPOUSE_INFO', {
    minSpouseAge,
    maxSpouseAge,
    minGranteeAge: minSpouseAge,
    maxGranteeAge: maxSpouseAge
  });

  return {
    minCustomerAge,
    maxCustomerAge,
    customerAgeInfoText,
    minSpouseAge,
    maxSpouseAge,
    spouseAgeInfoText
  };
};

export default getExtraLimitsAge;
